import React from 'react';

import { StyleGroupings } from 'reducers/detail/productDetail';
import { ProductStyle } from 'types/cloudCatalog';
import { AirplaneCache } from 'types/AirplaneCache';
import { makeSwatch, SwankySwatchBoxProps } from 'components/productdetail/swankyswatch/SwankySwatchBox';
import useMartyContext from 'hooks/useMartyContext';
import { findStyleById } from 'helpers/SwankySwatchUtils';

import css from 'styles/components/productdetail/swankyswatch/BeautySwatchGrouping.scss';

type OnChange<T> = (e: React.ChangeEvent<T>) => void;

interface BeautySwatchGroupingProps {
  styleList: ProductStyle[];
  styleIds: StyleGroupings | string[];
  subgroups?: StyleGroupings[];
  swankySwatchProps: SwankySwatchBoxProps;
  airplaneCache?: AirplaneCache;
  onColorChangeForSwatches: OnChange<HTMLInputElement>;
  isBeautySwatch: boolean;
  pageType: string;
}

export const BeautySwatchGrouping = (props: BeautySwatchGroupingProps) => {
  const { styleList, styleIds, subgroups, swankySwatchProps, airplaneCache, onColorChangeForSwatches, isBeautySwatch, pageType } = props;
  const { testId } = useMartyContext();

  if (subgroups) {
    return (
      <div className={css.beautyGrouping}>
        {subgroups.map((subgroup: StyleGroupings) => {
          const { name, styleIds: subgroupStyleIds } = subgroup;
          const sortedStyleIds = JSON.parse(JSON.stringify(subgroupStyleIds)).sort((a: string, b: string) => a.localeCompare(b));

          return (
            <div className={isBeautySwatch ? css.beautySwatches : css.swatches} data-test-id={testId('styleSwatchContainer')} key={name}>
              <span className={css.colorTextLabel}>{name}</span>
              {sortedStyleIds.map((styleId: string) => {
                const style = findStyleById(styleList, styleId);
                if (style) {
                  return makeSwatch(swankySwatchProps, airplaneCache, style, onColorChangeForSwatches, isBeautySwatch, pageType);
                } else {
                  return null;
                }
              })}
            </div>
          );
        })}
      </div>
    );
  } else if (styleIds && Array.isArray(styleIds)) {
    return (
      <div className={isBeautySwatch ? css.beautySwatches : css.swatches} data-test-id={testId('styleSwatchContainer')}>
        {styleIds.map((styleId: string) => {
          const style = findStyleById(styleList, styleId);
          if (style) {
            return makeSwatch(swankySwatchProps, airplaneCache, style, onColorChangeForSwatches, isBeautySwatch, pageType);
          } else {
            return null;
          }
        })}
      </div>
    );
  } else {
    return null;
  }
};

export default BeautySwatchGrouping;
